// The top bar in App admin's look: the menu button (phone), where you are (group / page), the workflow manual (a new
// tab), whether the sending window is open, dark mode, and the user menu.
import { matchPath, useLocation } from 'react-router-dom'
import { BookOpen, Menu, Moon, Sun } from 'lucide-react'
import { HELP_LINKS } from '../menus'
import { SCREENS } from '../screens'
import { useDarkMode } from '../useDarkMode'
import { UserMenu } from './UserMenu'
import { useSidebar } from './useSidebar'
import { WindowBadge } from './WindowBadge'

export function TopBar() {
  const { pathname } = useLocation()
  const setSidebarOpen = useSidebar((state) => state.setOpen)
  const [dark, setDark] = useDarkMode()
  const here = SCREENS.find((screen) => matchPath(screen.path, pathname))
  return (
    <header className="flex h-12 shrink-0 items-center gap-2 border-b border-slate-200 bg-white px-2 dark:border-slate-700 dark:bg-surface-dark sm:px-3 lg:px-5">
      <button
        type="button"
        className="icon-btn md:hidden"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open menu"
      >
        <Menu size={18} />
      </button>
      <p className="min-w-0 flex-1 truncate text-xs text-muted" data-testid="breadcrumb">
        {here?.menu?.group && (
          <>
            {here.menu.group} <span aria-hidden="true">/</span>{' '}
          </>
        )}
        <span className="font-semibold text-default">{here?.title ?? 'Campaign portal'}</span>
      </p>
      <a
        href={HELP_LINKS[0].href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 px-2 py-1 text-xs font-semibold text-default hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800"
        title="Workflow manual (opens in a new tab)"
        data-testid="topbar-manual"
      >
        <BookOpen size={14} className="text-accent" />
        <span className="hidden sm:inline">Manual</span>
      </a>
      <WindowBadge />
      <button
        type="button"
        className="icon-btn"
        aria-label={dark ? 'Light mode' : 'Dark mode'}
        onClick={() => setDark(!dark)}
      >
        {dark ? <Sun size={17} className="text-accent" /> : <Moon size={17} />}
      </button>
      <div className="hidden h-5 w-px bg-slate-200 dark:bg-slate-600 sm:block" />
      <UserMenu />
    </header>
  )
}
